import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { 	searchDomain } from "@/services/api/cresivoxServer";
import { REDUCER_NAME, iMetaDataDTO,iDomainBuyPayload } from './Types';

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const vendorDomainSearch = createAsyncThunk<
    iGenericResponse<any | null> | null,
    iMetaDataDTO,
    {
        rejectValue: iStateMessage;
    }
>(
    curriedGetThunkName("vendorDomainSearch"),
     // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
    async (payload, { rejectWithValue }) => {
        try {
            //@ts-ignore
            const response = await 	searchDomain.vendorDomainSearch(payload);
            if (response) {
                const { httpStatusCode, data, message } = response;
                switch (httpStatusCode) {
                    case httpStatusCodes.SUCCESS_OK: {
                        if (data && data.data) {
                            return {
                                data: {
                                    data: data.data,
                                    message,
                                }
                            };
                        } else {
                            return rejectWithValue({
                                httpStatusCode,
                                message,
                            });
                        }
                    }
                    default: {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
            } else {
                return rejectWithValue({
                    message: "No response received",
                });
            }
        } catch (error) {
            return rejectWithValue({
                message: "Something went wrong while adding metadata",
            });
        }
    },
);



export const vendorDomainBuy = createAsyncThunk<
  iGenericResponse<any | null> | null,
  iDomainBuyPayload,
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("vendorDomainBuy"),
  async (payload, { rejectWithValue }) => {
    
    try {
      const response = await searchDomain.vendorDomainBuy(payload);

      if (response?.httpStatusCode === 200) {
        return response;
      }

      return rejectWithValue({
        httpStatusCode: response?.httpStatusCode,
        message: response?.message,
      });
    } catch (error) {
      return rejectWithValue({
        message: "Domain purchase failed",
      });
    }
  }
);




export const getDominDetail = createAsyncThunk<
  iGenericResponse<any | null> | null,
  string,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getDominDetail"),
  // @ts-expect-error
  async (domain, { rejectWithValue }) => {
    try {
      const response = await searchDomain.getDominDetail(domain);
      if (response) {
        const { httpStatusCode, data, message } = response;

        if (httpStatusCode === 200 && data) {
          return {
            data: {
              data,
              message,
            },
          };
        }

        return rejectWithValue({ httpStatusCode, message });
      }

      return rejectWithValue({ message: "No response received" });
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong while fetching domain details",
      });
    }
  }
);
